import { FuelTypeEnum, getFuelTypeLabel } from '../../../../enums/FuelTypeEnum';
import { useTranslation } from 'react-i18next';
import InputFilterItem from '../../../delivery/components/InputFilterItem';
import ParcelFilterStyle from '../../../delivery/components/ParcelFilterStyle';
import { getSmartLabelClassName } from '../../../../utils/labelWidthUtils';

export interface FilterOptions {
  licensePlate: string;
  vehicleTypeId: number | null;
  fuelType: number | null;
  status: number | null;
}

export const DEFAULT_FILTER_OPTIONS: FilterOptions = {
  licensePlate: '',
  vehicleTypeId: null,
  fuelType: null,
  status: null,
};

interface FilterAreaProps {
  filters: FilterOptions;
  onFilterChange: (name: string, value: any) => void;
  modelOptions: { label: string; value: number }[];
  statusOptions: { label: string; value: number }[];
}

const FilterArea: React.FC<FilterAreaProps> = ({ filters, onFilterChange, modelOptions, statusOptions }) => {
  const { t } = useTranslation();

  const labelLicensePlate = String(t('pickup.vehicle.filters.licensePlate'));
  const labelModel = String(t('pickup.vehicle.filters.model'));
  const labelFuelType = String(t('pickup.vehicle.filters.fuelType'));
  const labelStatus = String(t('pickup.vehicle.filters.status'));

  const col1Labels = [labelLicensePlate, labelStatus];
  const col2Labels = [labelModel];
  const col3Labels = [labelFuelType];
  
  const fuelTypeOptions = [
    ...Object.values(FuelTypeEnum)
      .filter(v => typeof v === 'number')
      .map(v => ({ label: getFuelTypeLabel(v as FuelTypeEnum, t), value: v as number })),
  ];

  return (
    <div className="mb-2 pl-0 py-2">
      {/* 使用 Grid 布局确保列对齐 */}
      <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
        <div className="min-w-0">
          <InputFilterItem
            label={labelLicensePlate}
            value={filters.licensePlate}
            onChange={e => onFilterChange('licensePlate', e.target.value)}
            spanClassName={getSmartLabelClassName(col1Labels)}
          />
        </div>
        <div className="min-w-0">
          <ParcelFilterStyle
            label={labelModel}
            options={modelOptions}
            value={filters.vehicleTypeId !== null ? String(filters.vehicleTypeId) : undefined}
            onChange={(value: string) => onFilterChange('vehicleTypeId', value ? Number(value) : null)}
            spanClassName={getSmartLabelClassName(col2Labels)}
            className="w-full"
            placeholder={t('pickup.vehicle.placeholders.all') as string}
            showSearch
          />
        </div>
        <div className="min-w-0">
          <ParcelFilterStyle
            label={labelFuelType}
            options={fuelTypeOptions}
            value={filters.fuelType !== null ? String(filters.fuelType) : undefined}
            onChange={(value: string) => onFilterChange('fuelType', value ? Number(value) : null)}
            spanClassName={getSmartLabelClassName(col3Labels)}
            className="w-full"
            placeholder={t('pickup.vehicle.placeholders.all') as string}
            showSearch
          />
        </div>
        {/* 第二行 */}
        <div className="min-w-0">
          <ParcelFilterStyle
            label={labelStatus}
            options={statusOptions}
            value={filters.status !== null ? String(filters.status) : undefined}
            onChange={(value: string) => onFilterChange('status', value ? Number(value) : null)}
            spanClassName={getSmartLabelClassName(col1Labels)}
            className="w-full"
            placeholder={t('pickup.vehicle.placeholders.all') as string}
            showSearch
          />
        </div>
        <div className="min-w-0"></div>
        <div className="min-w-0"></div>
      </div>
    </div>
  );
};

export default FilterArea;
